<div class="px-3 py-2 h-full rounded-md bg-white border-1 border-[#d9d9d9] mb-2 sm-mb-0">
   <div class="flex items-start justify-start gap-2 mb-3">
    <img class="size-6" src="/assets/images/chart/chart.png" alt="Gold Silver Chart">
    <p class="font-bold text-base text-444">Gold - Silver History </p>
   </div>
    <div class="chart-container w-full h-[calc(100%-20%)]">
        <canvas #historyChart></canvas>
    </div>
</div>

